import { fileUpload } from "directus/src/operations";
import React, { useState, useEffect } from "react";
import { toast } from "sonner";
import FileUpload from "ui/components/comp-126";

const FileInput = ({
  value,
  className,
  objectFit,
  onChange,
  error,
  disabled,
  maxFileSize = 20,
  accept = "image/*,video/*,application/pdf",
  ...props
}) => {
  const [selectedFile, setSelectedFile] = useState(value || "");
  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (value) {
      setSelectedFile(value);
    } else {
      setSelectedFile("");
    }
  }, [value]);

  async function handleChange(file) {
    if (disabled) return;

    if (file && file.file) {
      const maxSizeInBytes = maxFileSize * 1024 * 1024; // Convert MB to bytes
      const fileSize = file.file.size;
      if (fileSize > maxSizeInBytes) {
        toast.error(
          `File size exceeds the maximum limit of ${maxFileSize} MB. Please select a smaller file.`
        );
        setSelectedFile(value || "");
        onChange?.(null);
        setResetKey((prev) => prev + 1);
        return;
      }
    }

    setSelectedFile(file);
    if (file) {
      try {
        const formData = new FormData();
        formData.append("file", file.file);
        const uploaded = await fileUpload(formData);
        onChange?.(uploaded.id);
      } catch (error) {
        console.error("File upload failed:", error);
        onChange?.(null);
      }
    } else {
      onChange?.(null);
    }
  }

  if (error) {
    return (
      <div className="text-red-500 text-sm">Error loading file: {error}</div>
    );
  }

  return (
    <FileUpload
      key={resetKey}
      className={className}
      objectFit={objectFit}
      value={selectedFile}
      onChange={handleChange}
      disabled={disabled}
      accept={accept}
      {...props}
    />
  );
};

export default FileInput;
